import { render, staticRenderFns } from "./PublishDigitalSignage.vue?vue&type=template&id=1c528b6d&scoped=true"
import script from "./PublishDigitalSignage.ts?vue&type=script&lang=js&external"
export * from "./PublishDigitalSignage.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c528b6d",
  null
  
)

export default component.exports